import { SignUpContent } from "@/features/sign-up";
import { Layout } from "../Layout";

export const SignUp = () => {
  return (
    <Layout>
      <SignUpContent />
    </Layout>
  );
};
